<!--     
    Copyright (c) 2022 nVipani Technology Solutions Private Limited.
    All rights reserved.
  -->
<div fxLayout="row" fxLayoutAlign="center center">
  <div fxFlex="65" fxLayout="column">
    <h3 class="title">{{ title }}</h3>
    <p>{{ quantity }} products</p>
  </div>
  <div fxFlex="20">
    <button
      class="view notranslate"
      *ngIf="quantity > 3"
      (click)="navigate()"
      i18n
    >
      VIEW >
    </button>
  </div>
</div>
